import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Luxuryurbaniarentalsinahemednagar() {



    const cardData =
    {
        keyword: 'Luxury Urbania Rentals in Ahmednagar',
        heading: 'Urbania on rent in pune: Luxury Urbania Rentals in Ahmednagar',
        headingDescription: 'Urbania On Rent in Pune offers premium and dependable Luxury Urbania Rentals in Ahmednagar for corporate groups, families, tourists, and event travelers planning comfortable group travel to and from Ahmednagar. Our well-maintained luxury Force Urbania fleet provides spacious seating, plush interiors, powerful air-conditioning, and smooth performance, making it ideal for long-distance journeys, airport transfers, corporate outings, weddings, sightseeing tours, and outstation trips between Pune and Ahmednagar. With professional chauffeurs, flexible one-way and round-trip rental options, and convenient doorstep pickup from major areas including Hinjewadi, Baner, Wakad, Kharadi, Hadapsar, Kothrud, Pimpri Chinchwad, and Pune Airport, we ensure a refined, punctual, and stress-free travel experience. Backed by 24/7 booking support, transparent pricing, and trusted service, Urbania On Rent in Pune stands out as the preferred choice for luxury Urbania rentals in Ahmednagar.',

        top: 'Top Places to Visit in Ahmednagar with Urbania on rent in pune',


"topPlaces": [
  {
    "title": "Ahmednagar Fort",
    "description": "Ahmednagar Fort is a massive historical fortification built in the 15th century by Malik Ahmad Nizam Shah. Known for its circular design and strong defensive architecture, the fort has witnessed many important events in Indian history, including the imprisonment of freedom fighters like Jawaharlal Nehru. Surrounded by a deep moat, the fort houses old cannons, gates, and inner structures that reflect Deccan Sultanate military brilliance. It is a must-visit destination for history lovers and architecture enthusiasts."
  },
  {
    "title": "Meherabad",
    "description": "Meherabad is a globally known spiritual site and the samadhi of spiritual master Meher Baba. Located on a hill near Ahmednagar, the place attracts devotees from all over the world seeking peace, meditation, and spiritual awakening. The serene atmosphere, white marble tomb, and panoramic hill views make it a calm and uplifting destination. Silence Day celebrations held annually draw thousands of followers."
  },
  {
    "title": "Shirdi",
    "description": "Located close to Ahmednagar, Shirdi is one of India’s most famous pilgrimage destinations dedicated to Sai Baba. Devotees visit the Sai Baba Samadhi Mandir to seek blessings, peace, and spiritual fulfillment. The town also features Dwarkamai, Chavadi, and Gurusthan, which are deeply connected to Sai Baba’s life. Shirdi’s devotional environment makes it an essential visit for spiritual travelers."
  },
  {
    "title": "Ralegan Siddhi",
    "description": "Ralegan Siddhi is a model village known worldwide for its transformation under the leadership of social activist Anna Hazare. The village represents sustainable development, water conservation, and rural self-reliance. Visitors come here to learn about eco-friendly practices, community living, and grassroots governance. It is an inspiring destination for students, researchers, and socially conscious travelers."
  },
  {
    "title": "Cavalry Tank Museum",
    "description": "The Cavalry Tank Museum is India’s only museum dedicated to tanks and armored vehicles. It showcases a wide range of historic tanks used by the Indian Army, including World War-era models. Located on the outskirts of Ahmednagar, the museum offers an educational and patriotic experience for visitors. It is especially popular among defense enthusiasts and families."
  },
  {
    "title": "Chand Bibi Mahal (Salabat Khan’s Tomb)",
    "description": "Chand Bibi Mahal is an elegant tomb located on a hilltop, built in memory of Salabat Khan II. The monument is associated with Chand Bibi, one of the most powerful women rulers of the Deccan. The structure features beautiful arches, domes, and scenic surroundings. The elevated location offers breathtaking views of Ahmednagar city, making it a great spot for photography."
  },
  {
    "title": "Bhandardara",
    "description": "Bhandardara is a beautiful hill station near Ahmednagar, known for its lakes, waterfalls, and lush greenery. Attractions like Arthur Lake, Wilson Dam, and Randha Falls make it a perfect nature getaway. During monsoon, the region transforms into a paradise with misty hills and flowing streams. It is ideal for trekking, camping, and relaxation."
  },
  {
    "title": "Mula Dam",
    "description": "Mula Dam is a peaceful reservoir offering scenic views and a calm natural environment. Surrounded by open landscapes and greenery, it is a popular spot for picnics and evening outings. The dam area provides a refreshing break from city life and is suitable for nature photography and quiet relaxation."
  },
  {
    "title": "Amruteshwar Temple, Ratanwadi",
    "description": "Amruteshwar Temple is an ancient Shiva temple located in the village of Ratanwadi near Ahmednagar. Built in Hemadpanthi architectural style, the temple is surrounded by hills, forests, and the Pravara River. The peaceful setting and historical carvings make it a hidden gem for devotees and heritage lovers alike."
  },
  {
    "title": "Randha Falls",
    "description": "Randha Falls is one of Maharashtra’s most powerful waterfalls, located near Bhandardara. The Pravara River plunges into a deep gorge, creating a dramatic and thunderous waterfall, especially during monsoon season. The surrounding rocky terrain and misty views make it a thrilling destination for nature lovers and photographers."
  },
  {
    "title": "Wilson Dam",
    "description": "Wilson Dam, built on the Pravara River, is one of the oldest dams in India. Located near Bhandardara, the dam offers stunning views of overflowing waters during monsoon and peaceful scenery during other seasons. It is a popular tourist attraction for sightseeing, photography, and enjoying cool mountain air."
  }
],






"services": [
{
"name": "Luxury Urbania Rentals in Ahmednagar",
"description": "Luxury Urbania Rentals in Ahmednagar provides premium, well-maintained Urbania buses designed for travelers who expect superior comfort and class. These luxury buses are ideal for city travel, outstation journeys, and special occasions, featuring plush seating, elegant interiors, ample legroom, and professional chauffeurs to ensure a smooth, relaxed, and memorable travel experience across Ahmednagar and nearby destinations."
},
{
"name": "Ahmednagar Luxury Urbania Hire",
"description": "Ahmednagar Luxury Urbania Hire offers high-end Urbania bus rental solutions for families, corporate clients, and tourists. With modern amenities, air-conditioned interiors, and experienced drivers, this service guarantees comfort, safety, punctuality, and a refined journey for every trip."
},
{
"name": "Premium Urbania Bus Ahmednagar",
"description": "Premium Urbania Bus Ahmednagar delivers upscale travel with luxury seating, advanced features, and spacious interiors. Suitable for corporate travel, family tours, VIP movements, and leisure trips, ensuring a premium experience from start to finish."
},
{
"name": "Urbania AC Luxury Bus Ahmednagar",
"description": "Urbania AC Luxury Bus Ahmednagar provides fully air-conditioned luxury buses designed for both short city rides and long-distance travel. The climate-controlled environment, smooth suspension, and skilled chauffeurs ensure maximum comfort even on extended journeys."
},
{
"name": "Corporate Luxury Urbania Hire Ahmednagar",
"description": "Corporate Luxury Urbania Hire Ahmednagar offers professional and stylish transportation for executives, business meetings, corporate events, and office outings. The service focuses on punctuality, premium comfort, and discreet, trained chauffeurs for a seamless corporate travel experience."
},
{
"name": "Luxury Urbania for Outstation Ahmednagar",
"description": "Luxury Urbania for Outstation Ahmednagar provides premium buses for intercity travel, weekend getaways, and long-distance tours. With comfortable seating, ample luggage space, and reliable drivers, passengers can enjoy a relaxed and luxurious outstation journey."
},
{
"name": "Chauffeur Driven Luxury Urbania Ahmednagar",
"description": "Chauffeur Driven Luxury Urbania Ahmednagar ensures a stress-free travel experience with professionally trained, verified drivers. Ideal for families, tourists, and corporate clients who value safety, comfort, smooth driving, and courteous service."
},
{
"name": "Wedding Luxury Urbania Ahmednagar",
"description": "Wedding Luxury Urbania Ahmednagar offers elegant and spacious luxury buses for transporting wedding guests and family members. These premium vehicles add comfort, style, and convenience to wedding functions, receptions, and ceremonial travel."
},
{
"name": "Family Tour Luxury Urbania Ahmednagar",
"description": "Family Tour Luxury Urbania Ahmednagar provides comfortable and luxurious travel solutions for family vacations, holiday trips, and sightseeing tours. The spacious interiors and smooth ride make long journeys enjoyable for all age groups."
},
{
"name": "Best Luxury Urbania Rental Ahmednagar",
"description": "Best Luxury Urbania Rental Ahmednagar is known for offering top-quality Urbania buses with excellent customer service, clean interiors, timely pickups, and dependable travel solutions for both local and outstation requirements."
},
{
"name": "Executive Urbania Hire Ahmednagar",
"description": "Executive Urbania Hire Ahmednagar caters to senior executives, VIP guests, and business delegations. Featuring luxury interiors, privacy, and professional chauffeurs, it ensures a premium and dignified travel experience."
},
{
"name": "Comfortable Luxury Urbania Ahmednagar",
"description": "Comfortable Luxury Urbania Ahmednagar focuses on providing a smooth, relaxing ride with ergonomic seating, ample legroom, and refined interiors, making every journey pleasant and fatigue-free."
},
{
"name": "High End Urbania Rental Ahmednagar",
"description": "High End Urbania Rental Ahmednagar offers exclusive luxury buses for travelers seeking superior quality, modern features, and reliable service. Perfect for premium travel needs and special occasions."
},
{
"name": "Trusted Luxury Urbania Service Ahmednagar",
"description": "Trusted Luxury Urbania Service Ahmednagar is recognized for its reliability, safety standards, and premium fleet. Customers rely on this service for consistent quality, professional drivers, and hassle-free luxury travel."
},
{
"name": "Luxury Tourist Urbania Ahmednagar",
"description": "Luxury Tourist Urbania Ahmednagar provides premium Urbania buses for tourists exploring Ahmednagar and nearby attractions. With comfort-focused design and experienced drivers, it ensures an enjoyable and memorable sightseeing experience."
}
],
"tableData": [
["Luxury Urbania Rentals in Ahmednagar", "Ahmednagar Luxury Urbania Hire"],
["Premium Urbania Bus Ahmednagar", "Urbania AC Luxury Bus Ahmednagar"],
["Corporate Luxury Urbania Hire Ahmednagar", "Luxury Urbania for Outstation Ahmednagar"],
["Chauffeur Driven Luxury Urbania Ahmednagar", "Wedding Luxury Urbania Ahmednagar"],
["Family Tour Luxury Urbania Ahmednagar", "Best Luxury Urbania Rental Ahmednagar"],
["Executive Urbania Hire Ahmednagar", "Comfortable Luxury Urbania Ahmednagar"],
["High End Urbania Rental Ahmednagar", "Trusted Luxury Urbania Service Ahmednagar"],
["Luxury Tourist Urbania Ahmednagar", ""]
],



"whychoose": [
    {
        "WhyChooseheading": "Luxury Urbania Rentals in Ahmednagar",
        "WhyChoosedescription": "Luxury Urbania Rentals in Ahmednagar are perfect for premium group travel, family outings, corporate trips, weddings, and outstation journeys, offering spacious seating and superior comfort."
    },
    {
        "WhyChooseheading": "Premium and Well-Equipped Force Urbania Buses",
        "WhyChoosedescription": "Luxury Urbania Rentals in Ahmednagar provide modern Force Urbania buses with air-conditioning, plush pushback seats, ample legroom, ambient lighting, and premium interiors for a luxury travel experience."
    },
    {
        "WhyChooseheading": "Professional and Experienced Drivers",
        "WhyChoosedescription": "Luxury Urbania Rentals in Ahmednagar include trained and skilled drivers familiar with Ahmednagar, Pune, Shirdi, and nearby routes, ensuring safe and smooth journeys."
    },
    {
        "WhyChooseheading": "Transparent and Competitive Pricing",
        "WhyChoosedescription": "Choose Luxury Urbania Rentals in Ahmednagar for competitive rates with no hidden charges, ensuring premium travel at a fair price."
    },
    {
        "WhyChooseheading": "24/7 Booking and Customer Support",
        "WhyChoosedescription": "Luxury Urbania Rentals in Ahmednagar offer round-the-clock booking assistance and support for inquiries, reservations, and last-minute travel needs."
    },
    {
        "WhyChooseheading": "Flexible Rental Packages",
        "WhyChoosedescription": "Luxury Urbania Rentals in Ahmednagar are available for hourly rentals, full-day bookings, multi-day trips, corporate travel, weddings, and customized travel packages."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Buses",
        "WhyChoosedescription": "All buses under Luxury Urbania Rentals in Ahmednagar are regularly cleaned, sanitized, and maintained to ensure passenger safety and comfort."
    },
    {
        "WhyChooseheading": "Punctual and Reliable Service",
        "WhyChoosedescription": "Luxury Urbania Rentals in Ahmednagar guarantee on-time pickups and dependable service, providing a seamless and stress-free travel experience."
    }
]
}

const faqData = [
    {
        question: 'Are Luxury Urbania Rentals in Ahmednagar available for local and outstation travel?',
        answer: 'Yes, Luxury Urbania Rentals in Ahmednagar can be booked for city travel, corporate events, weddings, family outings, and long-distance journeys.',
    },
    {
        question: 'How can I book Luxury Urbania Rentals in Ahmednagar?',
        answer: 'You can book Luxury Urbania Rentals in Ahmednagar via phone, WhatsApp, or online for easy and quick reservations.',
    },
    {
        question: 'Why choose Luxury Urbania Rentals in Ahmednagar?',
        answer: 'Luxury Urbania Rentals in Ahmednagar offer premium interiors, spacious seating, professional drivers, clean buses, and transparent pricing for corporate, family, and group travel.',
    },
    {
        question: 'Are drivers experienced?',
        answer: 'Yes, all drivers for Luxury Urbania Rentals in Ahmednagar are licensed, trained, and experienced in handling luxury Force Urbania buses safely.',
    },
    {
        question: 'Can pickup and drop-off locations be customized?',
        answer: 'Absolutely. Luxury Urbania Rentals in Ahmednagar allow flexible pickup and drop locations across Ahmednagar and nearby areas.',
    },
    {
        question: 'Are Luxury Urbania Rentals in Ahmednagar available 24x7?',
        answer: 'Yes, Luxury Urbania Rentals in Ahmednagar operate 24x7 for all travel requirements.',
    },
    {
        question: 'Are hygiene and safety standards maintained?',
        answer: 'Yes, all buses are regularly sanitized, cleaned, and maintained to ensure passenger safety and comfort.',
    },
    {
        question: 'What payment options are available?',
        answer: 'Luxury Urbania Rentals in Ahmednagar accept UPI, digital wallets, credit/debit cards, bank transfers, and corporate billing options.',
    },
    {
        question: 'Is customer support available during the journey?',
        answer: 'Yes, dedicated customer support is available throughout your journey for smooth and stress-free travel.',
    },
    {
        question: 'Can these buses be used for corporate, weddings, and group travel?',
        answer: 'Yes, Luxury Urbania Rentals in Ahmednagar are ideal for corporate events, weddings, family outings, and premium group travel.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Santosh Patil',
        feedback: 'Luxury Urbania Rentals in Ahmednagar provided an excellent and comfortable experience for our corporate trip. Highly recommended.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Aarti Deshmukh',
        feedback: 'We booked Luxury Urbania Rentals in Ahmednagar for a family wedding. The bus was spacious, luxurious, and well-maintained.',
        rating: 5,
    },
    {
        id: 3,
        name: 'Mr. Rohan Jadhav',
        feedback: 'Luxury Urbania Rentals in Ahmednagar made our group travel smooth, comfortable, and stress-free. Excellent service.',
        rating: 5,
    },
];






























































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Urbania On Rent Pune", link: "urbania-on-rent-pune" },
        { place: "/images/keyword/2.jpg", text: "Urbania on Rent in Pimpri Chinchwad", link: "urbania-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/3.jpg", text: "Urbania Hire for Corporate Events in Pune", link: "urbania-hire-for-corporate-events-in-pune" },
        { place: "/images/keyword/4.jpg", text: "17 Seater Urbania on Rent in Pune", link: "17-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/5.jpg", text: "14 Seater Urbania on Rent in Pune", link: "14-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/6.jpg", text: "Urbania on Rent in Kharadi", link: "urbania-on-rent-in-kharadi" },
        { place: "/images/keyword/7.jpg", text: "Urbania on Rent in Hadapsar", link: "urbania-on-rent-in-hadapsar" },
        { place: "/images/keyword/8.jpg", text: "Urbania on Rent in Kothrud", link: "urbania-on-rent-in-kothrud" },
        { place: "/images/keyword/9.jpg", text: "Urbania On Rent in Bibwewadi", link: "urbania-on-rent-in-bibwewadi" },
        { place: "/images/keyword/10.jpg", text: "Urbania on Rent in Koregaon Park", link: "urbania-on-rent-in-koregaon-park" },
        { place: "/images/keyword/11.jpg", text: "Urbania On Rent in Kalyani Nagar", link: "urbania-on-rent-in-kalyani-nagar" },
        { place: "/images/keyword/12.jpg", text: "Urbania On Rent in Mundhwa Pune", link: "urbania-on-rent-in-mundhwa-pune" },
        { place: "/images/keyword/13.jpg", text: "Urbania Bus On Rent in Baner", link: "urbania-bus-on-rent-in-baner" },
        { place: "/images/keyword/14.jpg", text: "Urbania AC Bus On Rent in Aundh", link: "urbania-ac-bus-on-rent-in-aundh" },
        { place: "/images/keyword/15.jpg", text: "Urbania Bus On Rent in Hinjewadi", link: "urbania-bus-on-rent-in-hinjewadi" },
        { place: "/images/keyword/16.jpg", text: "Urbania on Rent in Bhosari", link: "urbania-on-rent-in-bhosari" },
        { place: "/images/keyword/17.jpg", text: "Urbania on Rent in Pune Station", link: "urbania-on-rent-in-pune-station" },
        { place: "/images/keyword/18.jpg", text: "Urbania On Rent in Chakan", link: "urbania-on-rent-in-chakan" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Moshi", link: "urbania-on-rent-in-moshi" },
        { place: "/images/keyword/20.jpg", text: "Urbania On Rent in Charholi Budruk", link: "urbania-on-rent-in-charholi-budruk" },
        { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Nigdi Pradhikaran", link: "urbania-on-rent-in-nigdi-pradhikaran" },
        { place: "/images/keyword/22.jpg", text: "Urbania On Rent in Lohegaon", link: "urbania-on-rent-in-lohegaon" },
        { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Wagholi", link: "urbania-on-rent-in-wagholi" },
        { place: "/images/keyword/24.jpg", text: "Urbania Rental Service in Pune", link: "urbania-rental-service-in-pune" },
        { place: "/images/keyword/25.jpg", text: "Best Urbania on Rent in Pune", link: "best-urbania-on-rent-in-pune" }
    ];















const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Luxury Urbania Rentals in Ahmednagar",
  "image": "https://urbaniaonrentpune.in/assets/images/luxury-urbania-ahmednagar.jpg",
  "description": "Luxury Urbania Rentals in Ahmednagar offer premium AC Urbania buses for corporate travel, weddings, family tours, executive trips, and outstation journeys. Chauffeur-driven luxury Urbania buses provide superior comfort, safety, and a high-end travel experience across Ahmednagar and surrounding areas.",
  "brand": {
    "@type": "Brand",
    "name": "Urbania on Rent in Pune"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "950",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4500",
    "availability": "https://schema.org/InStock",
    "url": "https://urbaniaonrentpune.in/luxury-urbania-rentals-ahmednagar"
  }
};



    return (
        <div>

<Helmet>
  <title>
    Call:+91 9209423113 | Luxury Urbania Rentals in Ahmednagar | Premium AC Urbania Hire 
  </title>

  <meta
    name="description"
    content="Book Luxury Urbania Rentals in Ahmednagar for corporate travel, weddings, family tours, executive trips, and outstation journeys. Premium AC Urbania buses with chauffeur-driven service ensure a comfortable, stylish, and high-end travel experience in Ahmednagar."
  />

  <meta
    name="keywords"
    content="Luxury Urbania Rentals in Ahmednagar, Ahmednagar Luxury Urbania Hire, Premium Urbania Bus Ahmednagar, Urbania AC Luxury Bus Ahmednagar, Corporate Luxury Urbania Hire Ahmednagar, Luxury Urbania for Outstation Ahmednagar, Chauffeur Driven Luxury Urbania Ahmednagar, Wedding Luxury Urbania Ahmednagar, Family Tour Luxury Urbania Ahmednagar, Best Luxury Urbania Rental Ahmednagar, Executive Urbania Hire Ahmednagar, Comfortable Luxury Urbania Ahmednagar, High End Urbania Rental Ahmednagar, Trusted Luxury Urbania Service Ahmednagar, Luxury Tourist Urbania Ahmednagar"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <div
                className="breadcumb-wrapper"
                
                data-overlay="black"
                data-opacity="3"
            >
                <div className="container">
                    <div className="breadcumb-content text-center">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/104.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>



                            <div className="shambhu-services">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="sh-service-card">

                                        <div className="sh-service-left">
                                            <div className="sh-service-icon">
                                                🚌
                                            </div>
                                        </div>

                                        <div className="sh-service-content">
                                            <h4 className="sh-service-title">{service.name}</h4>
                                            <p className="sh-service-desc">{service.description}</p>
                                        </div>

                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Urbania On rent in Pune </span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Urbania on rent in Pune </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919209423113" className="pc-call">+91 9209423113</a>
                                            <a href="tel:+917620411277 " className="pc-call">+91 7620411277 </a>
                                            <a href="tel:+919284718314" className="pc-call">+91 9284718314</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919209423113"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919209423113" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@urbaniaonrentpune.in" className="pc-email">
                                            booking@urbaniaonrentpune.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Urbania on rent in pune</strong><br />
                                            Saket Tata Power CHS, Swami Samarth Marg,
                                            Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                                            Maharashtra India - 400703
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Luxuryurbaniarentalsinahemednagar;